var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adminPage"},[(_vm.$vuetify.breakpoint.mobile)?_c('AdministrationPageMobile'):_c('AdministrationPageDesktop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }